export const HOUSE_ADDRESS_ITEMS = Object.freeze({
  CONDO_NAME: 'condoName',
  NUMBER: 'number',
  COMPLEMENT: 'complement',
  FLOOR: 'floor',
});
